import React from 'react';

const Footer = () => {
  return (
    <footer className='page-footer font-small pt-2'>
      <div className='footer-copyright text-center py-3'>
        © 2020 Copyright:
        <a href='http://dawid-dor.com/'> Dawid Dor</a>
      </div>
    </footer>
  );
};

export default Footer;
